import rightLinePromotionCard from '~/assets/icons/rightLinePromotionCard.svg';
import leftLinePromotionCard from '~/assets/icons/leftLinePromotionCard.svg';
import { COLORS } from '~/data/ui/colors';
import { CSSProperties } from 'react';
import theme from '~/theme';
import { styled } from '@mui/material';

const useStyles = () => ({
  root: {
    border: `1px solid ${COLORS.gray.dark5}`,
    borderRadius: '8px',
    background: 'white',
    position: 'relative',
    transition: 'all 0.16s ease',
    backgroundColor: COLORS.primary.light2,
    '&:hover': {
      border: `1px solid transparent`,
      boxShadow: `0 0 0 2px ${COLORS.primary.main}`,
    },
    width: '100%',
    height: '535px',
    overflow: 'hidden',
    [theme.breakpoints.up('md')]: {
      height: '100%',
    },
  },
  '& .carousel .control-dots .dot.selected, .carousel .control-dots .dot:hover ':
    {
      opacity: 1,
      backgroundColor: 'yellow',
    },

  cardContainer: {
    padding: '12px 16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    overFlow: 'hidden',
  },

  promotionCardContainer: {
    background: '#fff9cc',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: '32px',
  },

  rightLinePromotionStyle: {
    backgroundImage: `url(${rightLinePromotionCard.src})`,
    backgroundSize: '80%',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    width: '100%',
    height: '100%',
    maxWidth: '300px',
    top: 0,
    right: 0,
  },
  leftLinePromotionStyle: {
    backgroundImage: `url(${leftLinePromotionCard.src})`,
    backgroundSize: '60%',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    width: '100%',
    maxWidth: '300px',
    height: '100%',
    top: 280,
    left: -9,
  },

  buttonContainer: {
    width: '100%',
  },
  lastWordTitle: {
    position: 'relative',
    display: 'inline-flex',
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    '&.MuiTypography-root': {
      fontSize: '42px',
      lineHeight: '1',
    },
  },
  titleStyle: { fontSize: '42px', lineHeight: '1' },
  titleStyleSec: { fontSize: '32px' },

  lastWordIcon: {
    position: 'absolute',
    bottom: -10,
    left: 0,
  },
  contentContainer: {
    flex: '1',
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'right',
    flexDirection: 'column',
  },
  descriptionContainer: {
    maxWidth: '95%',
  },
  descriptionContainerSec: {
    padding: '1px 0',
    maxWidth: '95%',

    [theme.breakpoints.up('md')]: {
      maxWidth: '81%',
    },
  },
});

export const buttonStyle: CSSProperties = {
  width: '100%',
  marginTop: '8px',
  flexDirection: 'row-reverse',
  fontSize: '16px',
  gap: '5px',
};

export const LastWordIcon = styled('svg')(() => ({
  position: 'absolute',
  bottom: '-3px',
  left: 0,
  width: '110px',
}));

export const fundingPromotionStyle = styled('svg')(() => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  maxWidth: '300px',
  top: 0,
  left: 0,
}));

export const discountDecorationStyle = styled('svg')(() => ({
  position: 'absolute',
  bottom: '30px',
  width: '100%',
  maxWidth: '300px',
}));

export const contactUsPromotionStyle = styled('svg')(() => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
}));

export const tradeInPromotionStyle = styled('svg')(() => ({
  width: '100%',
  height: '100%',
}));

export const tradeInContainerPromotionTopStyle = {
  width: '100%',
  position: 'absolute',
  top: '-73px',
  right: '-177px',
  maxWidth: '382px',
};

export const rightStarContainerPromotionStyle = {
  width: '58px',
  position: 'absolute',
  top: '31px',
  right: '18px',
};

export const leftStarContainerPromotionStyle = {
  width: '58px',
  position: 'absolute',
  top: '31px',
  left: '18px',
};

export const tradeInContainerPromotionBottomStyle = {
  width: '100%',
  position: 'absolute',
  height: '69%',
  maxWidth: '300px',
  right: '0',
  left: '0',
  margin: '0 auto',
  bottom: '0',
};

export const contactUsContainerPromotionStyle = {
  width: '100%',
  height: '83%',
  position: 'absolute',
  bottom: '73px',
  right: '-70px',
  maxHeight: '272px',
  maxWidth: '599px',
};

export const fundingContainerPromotionStyle = {
  width: '100%',
  height: '57%',
  position: 'absolute',
};

export const contactUsTextContainerStyle: CSSProperties = {
  width: '100%',
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginTop: '106px',
};

export const tradeInTextContainerStyle: CSSProperties = {
  width: '100%',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginTop: '127px',
  flexDirection: 'column-reverse',
};

export const fundingTextContainerStyle: CSSProperties = {
  width: '100%',
  alignItems: 'flex-start',
  marginBottom: '45px',
  justifyContent: 'flex-end',
};

export const cardBackgroundStyle = {
  width: '100%',
  height: '100%',
};

export const discountContainerStyle = {
  background: '#fff9cc',
  justContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  zIndex: 1,
};

export const discountDecorationContainerStyle = {
  position: 'absolute',
  bottom: '30px',
  right: '20px',
  zIndex: 1,
};

export default useStyles;
